// src/pages/LogoutPage.js
import React, { useEffect } from 'react';
import Footer from '../components/Footer';

export default function LogoutPage() {
  const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

  document.title = "Logging out...";

  useEffect(() => {
    const performLogout = async () => {
      try {
        await fetch(`${API_URL}/api/logout`, {
          method: 'POST',
          credentials: 'include',
        });
      } catch (error) {
        console.error('Logout failed', error);
      }

      // Clear local storage
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        console.error('Failed to clear storage:', e);
      }

      // Redirect to login
      window.location.replace('/login');
    };

    performLogout();
  }, [API_URL]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: '#0a0a0a',
      color: '#fafafa',
      fontFamily: 'Inter, sans-serif'
    }}>
      <main style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem'
      }}>
        <h2 style={{ fontWeight: 700 }}>Logging out...</h2>
      </main>
      <Footer />
    </div>
  );
}
